export const useNodeEnv = () => {
  const env = window.env.NODE_ENV || 'development';
  const isProd = env === 'production';
  console.log('[test]: ',window.env.NODE_ENV )
  return { env, isProd }
}